import { render, staticRenderFns } from "./ComponentSlider.vue?vue&type=template&id=0d7937b2&scoped=true&"
import script from "./ComponentSlider.vue?vue&type=script&lang=js&"
export * from "./ComponentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSlider.vue?vue&type=style&index=0&id=0d7937b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7937b2",
  null
  
)

export default component.exports